import React, { useState } from 'react';
import ReactDOM from 'react-dom/client';
import './main.css';
import LoginPage from './pages/LoginPage.jsx';
import Layout from './components/Layout.jsx';
import ScorecardForm from './components/ScorecardForm.jsx';
import EvaluationsPage from './pages/EvaluationsPage.jsx';
import AppealsPage from './pages/AppealsPage.jsx';
import AdminDashboard from './pages/AdminDashboard.jsx';
import AgentsPage from './pages/AgentsPage.jsx';
import SettingsPage from './pages/SettingsPage.jsx';
import PublicScorecard from './pages/PublicScorecard.jsx';
import MyScorecardsPage from './pages/MyScorecardsPage.jsx';
import MyAppealsPage from './pages/MyAppealsPage.jsx';
import MyDashboardPage from './pages/MyDashboardPage.jsx';
import { getSessionToken, getUser } from './lib/api.js';

function App() {
  const [loggedIn, setLoggedIn] = useState(!!getSessionToken());
  const user = getUser();
  const [viewEval, setViewEval] = useState(null);
  const [page, setPage] = useState(user?.role === 'agent' ? 'my-dashboard' : 'new-eval');

  // Public scorecard page (no login needed)
  const urlPath = window.location.pathname;
  const scorecardMatch = urlPath.match(/^\/scorecard\/(.+)/);
  if (scorecardMatch) {
    return <PublicScorecard evalId={scorecardMatch[1]} />;
  }

  if (!loggedIn) return <LoginPage onLogin={() => setLoggedIn(true)} />;

  const renderPage = () => {
    switch (page) {
      case 'new-eval': return <ScorecardForm onSaved={() => setPage('evaluations')} onViewEval={(ev) => { setViewEval(ev); setPage('evaluations'); }} />;
      case 'evaluations': return <EvaluationsPage initialSelected={viewEval} onClearSelected={() => setViewEval(null)} />;
      case 'appeals': return <AppealsPage />;
      case 'dashboard': return <AdminDashboard />;
      case 'agents': return <AgentsPage />;
      case 'settings': return <SettingsPage />;
      case 'my-dashboard': return <MyDashboardPage />;
      case 'my-scorecards': return <MyScorecardsPage />;
      case 'my-appeals': return <MyAppealsPage />;
      default: return <ScorecardForm />;
    }
  };

  return (
    <Layout currentPage={page} onNavigate={setPage}>
      {renderPage()}
    </Layout>
  );
}

ReactDOM.createRoot(document.getElementById('root')).render(<App />);
